import { Card } from "@devhop/ui";
import type { AuditSummaryStats } from "@/modules/internal-audit/domain/repo/summary/get-stats";

type AuditSummaryTrendsProps = {
  stats: AuditSummaryStats;
};

export function AuditSummaryTrends({ stats }: AuditSummaryTrendsProps) {
  const { trends } = stats;

  if (trends.length === 0) return null;

  const maxValue = Math.max(
    ...trends.map((t) => t.totalAudits),
    1,
  );

  return (
    <Card className="p-6" data-tourid="summary-trends">
      <h2 className="mb-4 font-semibold text-lg">ແນວໂນ້ມການກວດສອບ (12 ເດືອນຜ່ານມາ)</h2>
      <div className="space-y-2">
        {trends.map((trend) => {
          const passRate =
            trend.totalAudits > 0
              ? Math.round((trend.passCount / trend.totalAudits) * 100)
              : 0;
          const failRate =
            trend.totalAudits > 0
              ? Math.round((trend.failCount / trend.totalAudits) * 100)
              : 0;

          return (
            <div key={trend.period} className="space-y-1">
              <div className="flex items-center justify-between text-sm">
                <span className="font-medium">{trend.period}</span>
                <span className="text-muted-foreground">
                  {trend.totalAudits} ຄັ້ງ
                </span>
              </div>
              <div className="relative h-8 w-full overflow-hidden rounded-full bg-muted">
                <div
                  className="absolute left-0 top-0 h-full bg-green-500 transition-all"
                  style={{
                    width: `${(trend.passCount / maxValue) * 100}%`,
                  }}
                />
                <div
                  className="absolute left-0 top-0 h-full bg-red-500 transition-all"
                  style={{
                    width: `${((trend.passCount + trend.failCount) / maxValue) * 100}%`,
                    marginLeft: `${(trend.passCount / maxValue) * 100}%`,
                  }}
                />
                <div className="absolute inset-0 flex items-center justify-center text-xs font-medium text-foreground">
                  {passRate}% ຜ່ານ | {failRate}% ບໍ່ຜ່ານ
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </Card>
  );
}

